export default __webpack_public_path__ + "static/media/Sage's Jerkin of the Green Ones.2097e479.jpg";